import 'babel-polyfill';
import $ from 'jquery';
import 'jquery-ujs';

// polyfills
import './polyfills';

// presenter and methods
import { articlesInit } from './articlesInit';
import { executeScriptsFromLiquidTags } from './liquidTags';
import { navigationInit } from './navigationInit';
import { snippetsInit } from './snippetsInit';

$(() => {
  articlesInit();
  executeScriptsFromLiquidTags();

  // return after initialization of articles for iframes
  // because we do not have navigation and snippets
  if ($('.iframe').length) return;

  // return after initialization of articles with quirion (webflow) layouts
  // because we do not have navigation and snippets there
  if ($('[data-wf-domain="www.quirion.de"]').length) return;

  navigationInit();
  snippetsInit();
});



// WEBPACK FOOTER //
// ./main.js